export const config = {
    appname: 'bblprivilege',
    client_id: '1913492792231145', // App ID
    facebook_app_id: '1913492792231145', // Facebook App ID (Should be the same)
    debug: true, //enable console.log

    // ------------- Development Settings ----------------
    api: 'apibbl2',
    agency_id: '',
    bzbsUrlOldSupport: 'https://dev.buzzebees.com',
    bzbsUrl: 'https://apibbl2.buzzebees-dev.com',
    bzbsModuleUrl: 'https://bblmodule.buzzebees-dev.com',
    apiShoppingCartUrl: 'https://shoppingcartmodule36.buzzebees-dev.com',
    webShoppingCartUrl: 'https://shoppingcartservice36.buzzebees-dev.com',
    bzbsBlobUrl: 'https://cdn.buzzebees-dev.com/th',
    miscUrl: 'https://devmisc.buzzebees.com',
    bzbsGaId: '',
    liffId: '',
    // ------------------ End Settings ---------------------
    fbLogOnUrl: 'https://www.facebook.com/dialog/oauth?',
    fbPermissions: [
        'email',
    ],

    firebase: {
        apiKey: "AIzaSyD8Fj3Q1JXlMOfZKKOJpGAmyAMSu-Bpghc",
        authDomain: "bbl-redemption-stg.firebaseapp.com",
        projectId: "bbl-redemption-stg",
        storageBucket: "bbl-redemption-stg.appspot.com",
        messagingSenderId: "993767862488",
        appId: "1:993767862488:web:2e9e6e96b9c906d0ff67ad",
        measurementId: "G-LYVP5JXMW6"
    },
    // extra
    gameLanding: "http://localhost:8081"
};
